import theme from '@boiler/theme'

export default theme
